import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, exhaustMap, map, mergeMap } from 'rxjs/operators';

import { MergeUsersGQL, MergeUsersOverrides } from 'src/generated/graphql.generated';

import { UserPageMergeConflictDialogActions } from './user-page-merge-conflict-dialog.actions';
import { userPageMergeConflictDialogFeature } from './user-page-merge-conflict-dialog.feature';

export const mergeUsers = createEffect((
  actions$ = inject(Actions),
  store = inject(Store),
  mergeUsersGQL = inject(MergeUsersGQL),
) => {
    return actions$.pipe(
      ofType(UserPageMergeConflictDialogActions.confirmButtonClicked),
      exhaustMap((action) => of(action).pipe(
        concatLatestFrom(() => store.select(userPageMergeConflictDialogFeature.selectUserPageMergeConflictDialogState)),
        mergeMap(([ _action, state ]) => {
            // Requirement: Preserve primary customer values unless the user explicitly selects a duplicate value.
            const mergeOverrides: MergeUsersOverrides = {};

            if (state.selectedCompany === 'duplicate' && state.company) {
              mergeOverrides.company = state.company.duplicateValue;
            }

            if (state.selectedBillingAddress === 'duplicate' && state.billingAddress) {
              mergeOverrides.billingAddress = state.billingAddress.duplicateId;
            }

            return mergeUsersGQL.mutate({
                primaryId: state.primaryId,
                duplicateId: state.duplicateId,
                mergeOverrides: Object.keys(mergeOverrides).length ? mergeOverrides : undefined,
            }).pipe(
              map(() => UserPageMergeConflictDialogActions.mergeUsersSuccess()),
            );
        }),
        catchError((error) => of(UserPageMergeConflictDialogActions.mergeUsersError({ error }))),
      )),
    );
}, { functional: true, dispatch: true });
